if (typeof window !== 'undefined') {
  const url = window.location.hostname;
  let env = 'local';
  let oneTagUrl = '';

  if (url.includes('developerit')) {
    env = 'qa';
    oneTagUrl = 'https://onetms-qa.capitalone.com/ot/ot.js';
  } else if (url.includes('developer.capitalone.com')) {
    env = 'prod';
    oneTagUrl = 'https://onetms.capitalone.com/ot/ot.js';
  }

  window.oneTagConfig = {
    oneTagProfile: 'others',
    oneTagEnv: env,
    app_id: 'api_digital_ext',
  };

  if (!window.oneTag) {
    window.oneTag = {};
    window.oneTagEventQueue = [];
    window.oneTag.track = function (eventType, dataObject) {
      window.oneTagEventQueue.push({
        eventType: eventType,
        dataObject: dataObject,
      });
    };
  }

  if (env !== 'local') {
    const oneTagScript = document.createElement('script');
    oneTagScript.async = true;
    oneTagScript.src = oneTagUrl;
    document.querySelector('head').appendChild(oneTagScript);
  }
}
